<template>
<div>
    <v-sheet>
      <div v-if="myState.pdf" id="my_pdf_viewer">
        <v-flex xs5 offset-xs7 lg2 offset-lg10 md2 offset-md10>
          <div>
            <v-btn icon :disabled="myState.zoom >= 5" @click="(myState.zoom+=0.25) & displayPdf() ">
              <v-icon>add</v-icon>
            </v-btn>


            <v-btn icon :disabled="myState.zoom <= 0.5" @click="(myState.zoom-=0.25) & displayPdf() ">
              <v-icon>remove</v-icon>
            </v-btn>
          </div>
        </v-flex>

        <div id="canvas_container">
          <canvas ref="canvas"></canvas>
        </div>
        <v-divider></v-divider>
        <div id="navigation_controls">
          <v-btn icon :disabled="myState.currentPage <= 1" @click="(myState.currentPage--) & displayPdf() ">
            <v-icon>chevron_left</v-icon>
          </v-btn>
          <v-btn icon :disabled="myState.pdf.numPages <= myState.currentPage" @click="(myState.currentPage++) & displayPdf() ">
            <v-icon>chevron_right</v-icon>
          </v-btn>
          <span>{{$t('base.page')}}:{{myState.currentPage}}</span>
        </div>
      </div>
      <v-progress-circular indeterminate v-else :value="40"></v-progress-circular>
    </v-sheet>
</div>
</template>

<script>
import pdfjs from 'pdfjs-dist'

export default {
  components: {

  },
  props: ['file', 'base64'],
  data() {
    return {
      myState: {
        pdf: null,
        currentPage: 1,
        zoom: 1
      },
      beforeInit: true,
      loading: true,
      dialog: false,

    }
  },
  computed: {},
  watch: {
    file: function (file) {
      this.loadFile(file)
    },
    base64: function (base64) {
      this.loadBase64(base64)
    }
  },
  created() {
    return this.file ? this.loadFile(this.file) : this.base64 ?
      this.loadBase64(this.base64) : null
  },
  methods: {
    displayPdf() {
      this.myState.pdf.getPage(this.myState.currentPage).then((page) => {

        let canvas = this.$refs.canvas // document.getElementById("pdf_renderer");
        let ctx = canvas.getContext('2d');

        let viewport = page.getViewport(this.myState.zoom);
        if (this.beforeInit){
          viewport = this.getOptimalViewport(page)
        }

        this.beforeInit = false
        canvas.width =  viewport.width;
        canvas.height = viewport.height;

        page.render({
          canvasContext: ctx,
          viewport: viewport
        }).then(() => {
          this.$emit('page-rendered', canvas.toDataURL())
        });

      });

    },
    getOptimalViewport(page){
      let canvasContainerWidth = document.querySelector('#canvas_container').offsetWidth
      let isInDialog = canvasContainerWidth == 0 ? true : false
      let viewportBiggerThanWidth = false // init value. Real in while
      let width = isInDialog ? Math.max(window.screen.width, window.innerWidth) : canvasContainerWidth

      let i =0
      let maxItter = 30
      let viewport = page.getViewport(this.myState.zoom);
      while (viewport.width != width && i<maxItter && !isInDialog){
        i+=1

        if(viewport.width > width ){

          viewportBiggerThanWidth = true
          this.myState.zoom = this.myState.zoom * 0.95
          viewport = page.getViewport(this.myState.zoom);

        }else if(viewport.width < width ){

          if(viewportBiggerThanWidth){
            break
          }

          this.myState.zoom = this.myState.zoom * 1.05
          viewport = page.getViewport(this.myState.zoom);
        }
      }
      return viewport
    },
    loadPdf(pdfDocument) {
      pdfjs.getDocument(pdfDocument).then((pdf) => {
        this.myState.pdf = pdf;
        this.displayPdf()
      });
    },
    loadFile(file){
      let reader = new FileReader();
      reader.onload = (e) => this.loadPdf(new Uint8Array(e.target.result))
      reader.readAsArrayBuffer(file);
    },
    loadBase64(base64){
      if (!base64) {
        return
      }

      let arr = base64.split(','),
        bstr = atob(arr[1]),
        n = bstr.length, u8arr = new Uint8Array(n)

      while(n--){
        u8arr[n] = bstr.charCodeAt(n);
      }
      this.loadPdf(u8arr)
    }
  },
}
</script>

<style scoped>
#canvas_container{
  overflow-x: scroll;
}
</style>
